/**
 * NoticeList
 * --
 */
import { useState } from 'react';
import { Content, Title } from 'components';
import { Button, Table, Spin } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { strCut } from 'utils';
import moment from 'moment';
import { InquirySubType } from 'constants/InquirySubType';

/**----------------------------------------
 * [Component] 홈 > 매장별 매출 차트
 * ----------------------------------------
 */
const NoticeList = ({ data, isMobile }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */

  // JSX: start
  return (
    <>
      <Spin spinning={false}>
        <Content
          maxWidth={'100%'}
          height={320}
          borderRadius={4}
          // padding={'14px 5px'}
        >
          <Title
            size={5}
            style={{ marginBottom: 12, fontSize: isMobile ? 14 : 16 }}
            subButton={
              <Button
                size="small"
                onClick={() => window.open('/inquiry/list', '_blank')}
              >
                <ExportOutlined /> 문의관리
              </Button>
            }
          >
            답변 대기 문의
          </Title>

          <Table
            bordered
            size="small"
            scroll={{ x: 'max-content', y: 210 }}
            // style={{ height: 300 }}
            pagination={false}
            dataSource={data.slice(0, 10) ?? []}
            columns={[
              {
                title: (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    등록일(시간)
                  </p>
                ),
                dataIndex: 'created_at',
                width: isMobile ? 100 : 200,
                align: 'center',
                render: (v) => (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    {moment(v * 1000).format(
                      isMobile ? 'YY.MM.DD (HH:mm)' : 'YYYY-MM-DD (HH:mm:ss)'
                    )}
                  </p>
                ),
              },
              {
                title: (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    제목
                  </p>
                ),
                dataIndex: 'inquiry_name',
                width: isMobile ? 150 : 380,
                align: 'center',
                render: (v) => (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    {strCut(v, isMobile ? 30 : 55)}
                  </p>
                ),
              },
              {
                title: (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    내용
                  </p>
                ),
                dataIndex: 'inquiry_content',
                width: isMobile ? 200 : 450,
                align: 'center',
                render: (v) => (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    {strCut(v, isMobile ? 50 : 180)}
                  </p>
                ),
              },
              {
                title: (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    작성자
                  </p>
                ),
                dataIndex: 'user',
                width: isMobile ? 'auto' : 135,
                align: 'center',
                render: (user) => (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    {user.user_name}
                  </p>
                ),
              },
              {
                title: (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    문의유형
                  </p>
                ),
                dataIndex: 'inquiry_sub_type',
                width: isMobile ? 'auto' : 185,
                align: 'center',
                render: (value) => (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    {InquirySubType[value]?.label}
                  </p>
                ),
              },
            ]}
          />
        </Content>
      </Spin>
    </>
  ); // JSX: end
};

NoticeList.defaultProps = {
  onSelect: () => {},
};
export default NoticeList;
